import { render, staticRenderFns } from "./PromoteReturnsDetailed.vue?vue&type=template&id=c4a0a14c&scoped=true"
import script from "./PromoteReturnsDetailed.vue?vue&type=script&lang=js"
export * from "./PromoteReturnsDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a0a14c",
  null
  
)

export default component.exports